"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSSTTokenSchema = exports.SignatoryLinkStates = exports.SIGNATORY_MAX_AGE_DAYS = exports.SIGNATORY_URGENT_DAYS = exports.SignatoryTokenStatusSchema = exports.RequestSSTTokenBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.RequestSSTTokenBaseSchema = zod_1.z.object({
    sstId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    token: zod_1.z.string(),
    expiry: zod_1.z.date(),
    code: zod_1.z.string().length(4),
    reminderSentAt: zod_1.z.coerce.date().optional(),
    finalNotificationSentAt: zod_1.z.coerce.date().optional(),
});
/** Read-only token status attached to member SST list rows (not stored on RequestSST). */
exports.SignatoryTokenStatusSchema = zod_1.z.object({
    expiry: zod_1.z.string(),
    isExpired: zod_1.z.boolean(),
    reminderSentAt: zod_1.z.string().optional().nullable(),
    finalNotificationSentAt: zod_1.z.string().optional().nullable(),
});
/**
 * A link with this many days or fewer remaining is urgent — the same window the day-28 final
 * notice promises the signatory.
 */
exports.SIGNATORY_URGENT_DAYS = 2;
/**
 * Tokens older than this sit outside the reminder lifecycle: a token governed since day one
 * cannot exceed the auto-reject day plus its grace, so anything past this predates the feature
 * and belongs to admin cleanup rather than automated reminders.
 *
 * Shared deliberately: the scheduled task uses it to skip, and the admin queue uses it to define
 * the Abandoned bucket. If those two disagreed, admins would be triaging a different set of
 * requests than the one the task ignored.
 */
exports.SIGNATORY_MAX_AGE_DAYS = 45;
/** Signatory-link buckets backing the admin queue sub-filter. */
exports.SignatoryLinkStates = ['live', 'expiring', 'expired', 'abandoned'];
exports.RequestSSTTokenSchema = exports.RequestSSTTokenBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=RequestSSTToken.js.map